import { Tag } from "primereact/tag";
import { expiratedValues } from "../../models/expirated-values";

export const ExpiratedBodyTemplate = (rowData: any) => {
  const expiratedValue =
    expiratedValues.find((item) => item.value === rowData.status) ||
    expiratedValues[0];

  return (
    <Tag
      severity={expiratedValue.severity}
      value={expiratedValue.message}
      rounded
    />
  );
};
